import React from 'react';
import { Icon } from '@design-system';
import './Typography.scss';

export type TypographyProps = {
    intrinsic: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'span';
    variant?: 'sub' | 'secondary';
    defaultSpacing?: boolean;
    color?: 'green' | 'blue' | 'red' | 'yellow' | 'marine' | 'grey';
    iconColor?: 'green' | 'blue' | 'red' | 'yellow' | 'grey' | 'marine';
    icon?: React.ReactNode;
    iconFilled?: boolean;
    iconSize?: number;
    iconPosition?: 'left' | 'right';
} & React.HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement | HTMLSpanElement>;

export const Typography: React.FC<TypographyProps> = ({
    children,
    intrinsic,
    variant,
    defaultSpacing = false,
    color,
    icon,
    iconColor = 'marine',
    iconPosition = 'left',
    iconFilled = false,
    iconSize = 18,
    ...props
}) => {
    const Component = intrinsic;
    return (
        <Component
            {...props}
            data-variant={variant}
            data-default-spacing={defaultSpacing}
            data-color={color}
            data-icon-filled={iconFilled}
            data-icon-color={iconColor}
            style={{ whiteSpace: 'pre-wrap' }}
        >
            {icon && iconPosition === 'left' && (
                <Icon icon={icon} size={iconSize} color={iconColor} variant={iconFilled ? 'surrounded' : 'plain'} />
            )}
            {children}
            {icon && iconPosition === 'right' && (
                <Icon icon={icon} size={iconSize} color={iconColor} variant={iconFilled ? 'surrounded' : 'plain'} />
            )}
        </Component>
    );
};
